export default __webpack_public_path__ + "static/media/verb.2d4ed5f7.svg";